import { render, staticRenderFns } from "./CrudResources.vue?vue&type=template&id=6c198274&"
import script from "./CrudResources.vue?vue&type=script&lang=js&"
export * from "./CrudResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports